import React from "react";
import { Offcanvas } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FaFacebookF, FaTelegramPlane } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import { BsInstagram } from "react-icons/bs";
import scrollToSection from "../../utils/scrollToSection";
import { contacts } from "../../utils/contact";
import LanguageSwitcher from "../LanguageSwitcher";

const Sidebar = ({ show, handleClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="side__bar">
        <Offcanvas show={show} onHide={handleClose} placement="end">
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <br />
            <div className="text-white font-bold">
              <NavLink to="#" onClick={() => scrollToSection("home")}>
                {t("Navigation.Home")}
              </NavLink>
            </div>
            <div className="text-white font-bold">
              <NavLink to="#" onClick={() => scrollToSection("services")}>
                {t("Navigation.Services")}
              </NavLink>
            </div>
            <div className="text-white font-bold">
              <NavLink to="#" onClick={() => scrollToSection("hireUs")}>
                {t("Navigation.Why")}
              </NavLink>
            </div>
            <div className="text-white font-bold">
              <NavLink to="#" onClick={() => scrollToSection("whoWeAre")}>
                {t("Navigation.Who")}
              </NavLink>
            </div>
            <div className="contact-nav text-white font-bold">
              <NavLink to="#" onClick={() => scrollToSection("contacts")}>
                {t("Navigation.Contact")}
              </NavLink>
            </div>

            <div className="fix">
              <div className="side-info">
                <div className="side-info-content">
                  <div className="tp-mobile-menu"></div>
                  <div className="contact-infos mb-30">
                    <div className="contact-list mb-30">
                      <h4>Contact Info</h4>
                      <ul>
                        <li>
                          <i className="flaticon-email"></i>
                          <a href={`mailto:${contacts.email}`}>
                            {contacts.email}
                          </a>
                        </li>
                        <li>
                          <i className="flaticon-phone-call"></i>
                          <a href={`tel:${contacts.tel.replaceAll(" ", "")}`}>
                            {contacts.tel}
                          </a>
                        </li>
                        <li>
                          <i className="flaticon-phone-call"></i>
                          <a href={`tel:${contacts.tel2.replaceAll(" ", "")}`}>
                            {contacts.tel2}
                          </a>
                        </li>
                      </ul>
                      <div className="sidebar__menu--social">
                        <a className="text-white" href={contacts.telegramLink}>
                          <i>
                            <FaTelegramPlane className="icon" />{" "}
                          </i>
                        </a>
                        <a className="text-white" href={contacts.instagramLink}>
                          <i>
                            <BsInstagram className="icon" />{" "}
                          </i>
                        </a>
                        <a className="text-white" href={contacts.facebookLink}>
                          <i>
                            <FaFacebookF className="icon" />{" "}
                          </i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default Sidebar;
